/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ContactStatusType = {
    Started: 'Started',
    Ended: 'Ended',
    Closed: 'Closed'
} as const;
export type ContactStatusType = typeof ContactStatusType[keyof typeof ContactStatusType];


export function ContactStatusTypeFromJSON(json: any): ContactStatusType {
    return ContactStatusTypeFromJSONTyped(json, false);
}

export function ContactStatusTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactStatusType {
    return json as ContactStatusType;
}

export function ContactStatusTypeToJSON(value?: ContactStatusType | null): any {
    return value as any;
}

